<script>
  export default{
    name:'OtherPartyIcon'
  }
</script>

<template>
  <svg width="45" height="41" viewBox="0 0 45 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M41 36.1045H44.0597V41H0V36.1045H3.0597V31.8209H7.34328V17.1343H3.0597V12.4613L22.0299 0L41 12.4613V17.1343H36.7164V31.8209H41V36.1045ZM31.8209 17.1343H24.4776V31.8209H31.8209V17.1343ZM19.5821 17.1343H12.2388V31.8209H19.5821V17.1343Z" fill="#BEBEBE"/>
  </svg>
</template>
